//export const urlServer = 'http://localhost:5000/'
export const urlServer = 'https://megalotoserver-oficial.onrender.com'
export const keyMessenger = 'BK9GAcvt3AlZ6nWGHT_3OCQxVRhyG9hCzSkD2GuR30T_JOpcq86sfOoL_2mESQiiHpjD0XI9k_-oeoVIYJl8mCY'